// =============================================
// Hess Insurance Solutions - Mock Data
// =============================================

export const siteConfig = {
  name: "Hess Insurance Solutions",
  tagline: "Your Trusted Health Insurance Broker",
  phone: "919-909-2145",
  phoneFormatted: "(919) 909-2145",
  email: "Kim@HessInsuranceSolutions.com",
  address: {
    street: "5200 Duckdown Ct.",
    city: "Raleigh",
    state: "NC",
    zip: "27613",
  },
  hours: "Monday - Friday: 9AM - 5PM",
  licensedStates: "All 50 States",
  logo: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/uGVpUh5H17thixy70xyX/media/644ffe4a66ce957c82de4703.png",
  kimHeadshot: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/uGVpUh5H17thixy70xyX/media/69c72ea9a235aec742bc311f.png",
  kimHeroPhoto: "/images/kim-hero.png",
  kimAboutPreviewPhoto: "/images/kim-about.png",
  kimAboutPhoto: "/images/kim-about-page.png",
  socialLinks: {
    linkedin: "https://www.linkedin.com/in/kimberlyvhess/",
    instagram: "https://www.instagram.com/yourinsurancegirlkim/",
    facebook: "https://www.facebook.com/profile.php?id=61577923341637",
    tiktok: "https://www.tiktok.com/@yourinsurancegirlkim",
  },
  reviewUrl: "https://g.page/r/CVyaZdIYzUupEAI/review",
  calendlyUrl: "https://calendly.com/hesskimberly/15mindiscoverycall",
  lifeInsuranceQuoteUrl: "https://lifelink.simplicitygroup.com/agent/hess-4295?product=mpt",
  visionQuoteUrl: "https://directvisioninsurance.com/index.php?option=com_scoreboard&agent=0013b000023y7pjAAA",
  dentalQuoteUrl: "https://spiritdental.com/index.php?option=com_scoreboard&view=scoreboard&agent=0013b000023y7pjAAA",
  travelQuoteUrl: "https://www.azimuthrisk.com/?reference_id=a08f78fb",
};

export const navigation = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Who I Help", path: "/who-i-help" },
  { label: "Blog", path: "/blog" },
  { label: "Contact", path: "/contact" },
];

export const heroData = {
  headline: "Independent Health Insurance for Self-Employed Professionals Who Want Coverage That Actually Fits",
  subheadline: "I shop multiple carriers so you don't have to — and I'm here year-round when things change.",
  description: "No jargon. No pressure. Just honest guidance to help you find the right coverage at the right price.",
  ctaPrimary: { label: "Book a Free Call", path: "/contact" },
  ctaSecondary: { label: "Get a Quote", path: "/contact" },
};

export const aboutPreview = {
  name: "Kimberly Hess",
  title: "Licensed Health & Life Insurance Broker",
  bio: "Hi, I'm Kimberly — a mom, yoga instructor, and holistic health and fitness enthusiast who believes that health truly is wealth.",
  bioExtended: "I'm an independent health and life insurance broker based in Raleigh, North Carolina, licensed in all 50 states. I started Hess Insurance Solutions because I saw too many hardworking entrepreneurs and families feeling stuck, confused, or limited when it came to their health coverage. The truth is, there are more options out there than most people realize — even outside of Open Enrollment — and you deserve to understand them. My goal is simple: to give you clear, honest guidance so you can make confident decisions about your health and your future without pressure or confusion.",
  highlights: [
    "Independent broker — not tied to one carrier",
    "Licensed in all 50 states",
    "Based in Raleigh, NC",
    "Specializing in health & life insurance",
  ],
};

export const whoIHelp = [
  {
    id: 1,
    title: "Small Business Owners",
    description: "Affordable group health plans tailored to your team size and budget. I help you offer competitive benefits without the corporate price tag.",
    icon: "Building2",
    image: "https://images.unsplash.com/photo-1714976327299-398b8fcc2e06?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHxoYXBweSUyMHNtYWxsJTIwYnVzaW5lc3MlMjBvd25lciUyMHRlYW0lMjBvZmZpY2V8ZW58MHx8fHwxNzc2MzU0MjQ4fDA&ixlib=rb-4.1.0&q=85&w=600&h=450",
  },
  {
    id: 2,
    title: "Self-Employed Professionals",
    description: "Custom coverage that fits your freelance lifestyle. From consultants to contractors, I find plans that work as hard as you do.",
    icon: "Briefcase",
    image: "https://images.unsplash.com/photo-1758874384556-cc2b9dcbb6e0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxzbWlsaW5nJTIwc2VsZi1lbXBsb3llZCUyMHByb2Zlc3Npb25hbCUyMHdvcmtpbmclMjBsYXB0b3B8ZW58MHx8fHwxNzc2MzU0MjQ4fDA&ixlib=rb-4.1.0&q=85&w=600&h=450",
  },
  {
    id: 3,
    title: "Families",
    description: "Comprehensive family coverage that protects everyone under your roof. I make sure your family gets the care they need at a price that makes sense.",
    icon: "Heart",
    image: "https://images.unsplash.com/photo-1763013259279-3195d6330519?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxoYXBweSUyMGZhbWlseSUyMHBvcnRyYWl0JTIwc21pbGluZyUyMHRvZ2V0aGVyfGVufDB8fHx8MTc3NjM1NDI0OHww&ixlib=rb-4.1.0&q=85&w=600&h=450",
  },
  {
    id: 4,
    title: "Individuals",
    description: "Whether you're between jobs, aging off a parent's plan, or just need better coverage, I'll help you find the right fit.",
    icon: "User",
    image: "https://images.unsplash.com/photo-1765005204058-10418f5123c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxmcmllbmRseSUyMGNvbmZpZGVudCUyMHlvdW5nJTIwcHJvZmVzc2lvbmFsJTIwc21pbGluZ3xlbnwwfHx8fDE3NzYzNTQyNDh8MA&ixlib=rb-4.1.0&q=85&w=600&h=450",
  },
];

export const services = [
  {
    id: 1,
    title: "Health Insurance",
    description: "Individual and group health plans from multiple carriers. I compare options to find you the best coverage at the most competitive rates.",
    icon: "Shield",
    details: [
      "Individual & family plans",
      "PPO, HMO, and HSA-compatible options",
      "Plans often 40% less than marketplace alternatives",
      "Year-round enrollment available",
    ],
  },
  {
    id: 2,
    title: "Life Insurance",
    description: "Protect your family's financial future with affordable life insurance options tailored to your specific situation and goals.",
    icon: "HeartHandshake",
    details: [
      "Term & whole life options",
      "Competitive rates from top carriers",
      "Coverage for every budget",
      "Simple application process",
    ],
  },
  {
    id: 3,
    title: "Dental Coverage",
    description: "Coverage for preventive, routine dental care, and major dental care with plans that keep your smile healthy and your wallet happy.",
    icon: "Smile",
    details: [
      "Preventive care coverage",
      "Major dental procedures",
      "Wide network of dentists",
      "Affordable monthly premiums",
    ],
  },
  {
    id: 4,
    title: "Vision Coverage",
    description: "Protect your eyesight with comprehensive vision plans that cover exams, glasses, contacts, and more.",
    icon: "Eye",
    details: [
      "Annual eye exams",
      "Glasses & contact lenses",
      "Specialist referrals",
      "Flexible plan options",
    ],
  },
  {
    id: 5,
    title: "Small Business Plans",
    description: "Help your employees thrive with group health benefits that attract talent — healthcare your employees will actually use.",
    icon: "Building",
    details: [
      "Group health plans",
      "Scalable to your team size",
      "Tax advantages for employers",
      "Employee retention benefits",
    ],
  },
  {
    id: 6,
    title: "Supplemental Plans",
    description: "Extra protection for life's unexpected moments. Accident, critical illness, and hospital indemnity plans to fill the gaps.",
    icon: "Plus",
    details: [
      "Accident coverage",
      "Critical illness protection",
      "Hospital indemnity",
      "Maternity coverage options",
    ],
  },
  {
    id: 7,
    title: "Travel Insurance",
    description: "Protect your trip and your health while traveling abroad or domestically. Coverage for medical emergencies, trip interruptions, and unexpected events away from home.",
    icon: "Plane",
    details: [
      "International medical coverage",
      "Trip interruption & cancellation",
      "Emergency evacuation",
      "Short-term & long-term travel plans",
    ],
  },
];

export const whyDifferent = [
  {
    title: "Independent, Not Captive",
    description: "I'm not tied to a single insurance carrier. I shop the market for you, comparing plans from multiple companies to find the best fit.",
    icon: "Scale",
  },
  {
    title: "Clear, Simple Guidance",
    description: "Insurance doesn't have to be confusing. I break down your options in language that actually makes sense, so you can decide with confidence.",
    icon: "MessageCircle",
  },
  {
    title: "Personalized Approach",
    description: "No cookie-cutter plans here. I take the time to understand your specific situation — your health needs, your budget, your goals.",
    icon: "Target",
  },
  {
    title: "Ongoing Support",
    description: "My job doesn't end when you enroll. I'm here year-round to answer questions, help with claims, and review your coverage as your needs change.",
    icon: "LifeBuoy",
  },
  {
    title: "Save Up to 40%",
    description: "Many of my clients save significantly compared to marketplace alternatives — with better coverage and more flexibility.",
    icon: "BadgeDollarSign",
  },
  {
    title: "Nationwide Service",
    description: "Based in Raleigh, NC, but licensed in all 50 states. Wherever you are, I can help you find the right plan.",
    icon: "MapPin",
  },
];

export const processSteps = [
  {
    step: 1,
    title: "Learn",
    description: "We start with a conversation. Tell me about your situation, your needs, and your budget. I'll explain your options in clear, simple terms.",
    icon: "BookOpen",
  },
  {
    step: 2,
    title: "Compare",
    description: "I'll compare plans from multiple carriers to find the best coverage at the most competitive price.",
    icon: "ArrowLeftRight",
  },
  {
    step: 3,
    title: "Choose",
    description: "Once you've found the right plan, I'll handle the enrollment process and make sure everything is set up correctly.",
    icon: "CheckCircle",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Jeffrey Pickett",
    text: "Not a person who leaves a lot of reviews, but Kimberly was instrumental in helping me answer all the questions that I needed and becoming my agent. I have a few complex situations that she helped guide me and find the best workaround for my situation. Would highly recommend.",
    rating: 5,
  },
  {
    id: 2,
    name: "Katie Golinowski",
    text: "Kim was wonderful. She explained all of my options, walked me through all the details of the plan I chose and was just overall very thorough and extremely kind.",
    rating: 5,
  },
  {
    id: 3,
    name: "David Mansfield",
    text: "Kim is amazing and easy to work with! She explains things in this crazy health insurance world in a way that's understandable and clear. She gives many options and finds the right fit for you and your needs.",
    rating: 5,
  },
  {
    id: 4,
    name: "Frankie A",
    text: "I recently had the pleasure of working with Kim Hess to find the right insurance plan for my HVAC company's employees, and I can't recommend her highly enough. She went above and beyond to find a solution that was both affordable and a perfect fit for our team.",
    rating: 5,
  },
  {
    id: 5,
    name: "Destiny DiGirolamo",
    text: "Found our family a plan that gave us everything we need plus saved us a ton of money!!",
    rating: 5,
  },
  {
    id: 6,
    name: "Victoria Haffer",
    text: "Kimberly Hess has such an amazing way about her. She actually cares about her clients and will do her due diligence to get you the best policy for the best price! I would highly recommend Kimberly for all your health insurance needs.",
    rating: 5,
  },
  {
    id: 7,
    name: "Cameron Cochran",
    text: "I love working with Kim! She is very responsive and so helpful in answering any questions I have about my insurance policy. She has made everything super easy to set up and understand!",
    rating: 5,
  },
  {
    id: 8,
    name: "Marie Mantle",
    text: "Kimberly was so helpful in finding the right plan for my family and has saved us so much hassle with medical bills. She is very knowledgeable and also helped us with some other supplemental plans that are great for peace of mind.",
    rating: 5,
  },
];

export const comparisonData = {
  privateInsurance: {
    title: "Private Health Insurance",
    benefits: [
      "Larger network of doctors and hospitals",
      "Underwritten plans — discounts for being lower risk",
      "Lower premiums with increased benefit options",
      "Plans customized to your individual needs",
      "No referrals needed for specialists",
      "Nationwide coverage — not limited to local networks",
      "Year-round enrollment — no restricted periods",
      "24/7 customer support",
    ],
  },
  marketplaceInsurance: {
    title: "Marketplace Plans",
    benefits: [
      "Guaranteed coverage regardless of medical conditions",
      "Subsidy assistance for lower income households",
      "Standardized plan structures",
      "Multiple plan tiers to compare",
    ],
    limitations: [
      "Restricted enrollment periods",
      "Smaller in-network provider options",
      "Plans cannot be customized individually",
      "Referrals may be required for specialists",
    ],
  },
};

export const faqData = [
  {
    question: "Who is a good health insurance broker in Raleigh, NC?",
    answer: "Hess Insurance Solutions is an independent health insurance broker in Raleigh, NC, with over 20 years of combined industry experience helping individuals, families, and small business owners find ACA-qualified and private health insurance coverage.",
  },
  {
    question: "Does Hess Insurance Solutions sell Medicare plans?",
    answer: "No. Hess Insurance Solutions does not sell or enroll Medicare plans. For clients approaching Medicare age, we provide education and refer clients to trusted, licensed Medicare specialists.",
  },
  {
    question: "What type of health insurance does Hess Insurance Solutions specialize in?",
    answer: "ACA-qualified health plans and private health insurance options for self-employed professionals, families, and small businesses.",
  },
  {
    question: "Does Hess Insurance Solutions help small businesses with employee benefits?",
    answer: "Yes. We help small business owners in the Raleigh area evaluate current employee benefits programs, including newly available 2026 options.",
  },
  {
    question: "Is Hess Insurance Solutions only for Raleigh residents?",
    answer: "Not at all! While I'm proudly based in Raleigh, NC, I'm licensed in all 50 states. I serve clients nationwide, whether you're local to the Triangle area or across the country.",
  },
  {
    question: "How is private insurance different from marketplace plans?",
    answer: "Private insurance typically offers larger provider networks, customizable plans, lower premiums for healthy individuals, and year-round enrollment. Marketplace plans offer guaranteed acceptance regardless of health status and income-based subsidies. I can help you determine which option is best for your situation.",
  },
  {
    question: "Do I have to wait for open enrollment to get coverage?",
    answer: "With many private insurance plans, you can enroll at any time of the year. You don't have to wait for the marketplace open enrollment period. I'll help you understand your timing options.",
  },
  {
    question: "How much can I save by working with an independent broker?",
    answer: "Many of my clients save up to 40% compared to marketplace alternatives, while often getting better coverage and more flexibility. Every situation is different, so I'll provide a personalized comparison for your specific needs.",
  },
  {
    question: "Can you help small businesses set up group health insurance?",
    answer: "Absolutely. I work with small business owners of all sizes to create group health plans that fit their team and budget. I'll help you understand the options, handle the setup, and provide ongoing support.",
  },
  {
    question: "Is there a cost for your services?",
    answer: "There is no direct cost to you for my services. As a broker, I'm compensated by the insurance carriers. You get expert guidance and advocacy at no additional charge.",
  },
];

export const contactFormFields = [
  { name: "firstName", label: "First Name", type: "text", required: true },
  { name: "lastName", label: "Last Name", type: "text", required: true },
  { name: "email", label: "Email", type: "email", required: true },
  { name: "phone", label: "Phone", type: "tel", required: true },
  { name: "coverageType", label: "What type of coverage are you looking for?", type: "select", required: true, options: ["Individual", "Family", "Small Business / Group", "Self-Employed", "Other"] },
  { name: "message", label: "Tell me a little about your situation", type: "textarea", required: false },
];

export const stats = {
  reviewScore: "5.0",
  totalReviews: "52",
  statesLicensed: "50",
  yearsExperience: "5+",
};

export const featuredIndustries = [
  {
    title: "Small Businesses",
    icon: "Building2",
    description: "Private insurance gives small business owners the flexibility to select coverage perfectly matched to their needs, often at better rates than one-size-fits-all group plans. This tailored approach protects both personal health and business capital, creating the financial stability essential for sustainable growth.",
  },
  {
    title: "Self-Employed",
    icon: "Briefcase",
    description: "Private insurance empowers self-employed professionals to secure customized health coverage that accommodates variable income streams and specific health needs while providing the continuous protection essential for independent career success.",
  },
  {
    title: "Travel Nurses",
    icon: "Stethoscope",
    description: "Private insurance offers travel nurses consistent, nationwide coverage that follows them across state lines and between assignments, eliminating the gaps and administrative headaches of frequently changing employer-sponsored plans.",
  },
  {
    title: "Truck Drivers",
    icon: "Truck",
    description: "Private insurance provides long-haul truck drivers with consistent, nationwide coverage that remains stable despite changing routes, multiple state crossings, and irregular work schedules \u2014 offering peace of mind on the road.",
  },
  {
    title: "Contractors",
    icon: "Wrench",
    description: "HVAC, plumbing, and electrical contractors gain financial security through private insurance plans that offer consistent coverage regardless of project cycles, with customized protection addressing trade-specific health risks.",
  },
  {
    title: "Lawyers",
    icon: "Scale",
    description: "Private insurance gives independent attorneys and legal consultants the flexibility to secure comprehensive coverage that accommodates unpredictable schedules, while potentially offering significant tax advantages for practice profitability.",
  },
];

export const industryCategories = [
  {
    title: "Technology & IT",
    icon: "Monitor",
    items: ["Freelance Software Developers", "Independent IT Consultants", "App Developers", "DevOps Specialists", "Database Administrators", "Network Engineers", "UI/UX Designers", "Systems Analysts", "Cybersecurity Consultants", "Technical Writers", "QA Testers", "Blockchain Developers", "Cloud Solution Architects", "AI/ML Specialists", "Game Developers"],
  },
  {
    title: "Creative & Media",
    icon: "Palette",
    items: ["Commercial Photographers", "Video Producers/Directors", "Graphic Designers", "Animation Specialists", "YouTubers & Streamers", "Podcast Producers", "Voice-Over Artists", "Independent Filmmakers", "Copy Editors", "Audio Engineers", "Music Producers", "Authors & Writers", "Professional Bloggers", "Social Media Consultants", "Content Strategists"],
  },
  {
    title: "Business & Finance",
    icon: "TrendingUp",
    items: ["Independent Financial Advisors", "Management Consultants", "Business Coaches", "Investment Advisors", "Tax Preparers", "Forensic Accountants", "Business Appraisers", "Economic Consultants", "Retirement Planners", "Wealth Managers", "Franchise Owners", "Day Traders", "E-Commerce Business Owners", "Compensation Consultants", "Risk Management Consultants"],
  },
  {
    title: "Real Estate & Construction",
    icon: "Home",
    items: ["Real Estate Agents & Brokers", "Property Developers", "Home Inspectors", "Appraisers", "Specialized Construction Contractors", "Interior Designers", "Landscape Architects", "Commercial Property Managers", "General Contractors", "Sustainable Building Consultants", "Home Stagers", "Real Estate Photographers", "Rental Property Investors", "Construction Project Managers", "Historic Preservation Specialists"],
  },
  {
    title: "Legal & Professional Services",
    icon: "Gavel",
    items: ["Contract Attorneys", "Legal Consultants", "Expert Witnesses", "Court Reporters", "Private Investigators", "Patent Agents", "Mediators & Arbitrators", "Legal Translators", "Immigration Consultants", "Compliance Specialists", "Paralegals", "Legal Tech Consultants", "Trademark Specialists", "Process Servers", "Litigation Support"],
  },
  {
    title: "Health & Wellness",
    icon: "HeartPulse",
    items: ["Private Practice Therapists", "Independent Nutritionists", "Chiropractors", "Acupuncturists", "Personal Trainers", "Health Coaches", "Massage Therapists", "Dietitians", "Speech Pathologists", "Occupational Therapists", "Physical Therapists", "Midwives", "Telehealth Providers", "Medical Billing Consultants", "Wellness Retreat Operators"],
  },
  {
    title: "Education & Training",
    icon: "GraduationCap",
    items: ["Corporate Trainers", "Educational Consultants", "Curriculum Developers", "Test Prep Specialists", "Executive Coaches", "E-Learning Developers", "College Admissions Consultants", "Specialized Tutors", "Workshop Facilitators", "Adult Education Instructors", "Language Instructors", "Educational Technology Consultants", "Professional Development Consultants", "Independent School Administrators", "STEM Educators"],
  },
  {
    title: "Sales & Marketing",
    icon: "Megaphone",
    items: ["Independent Sales Representatives", "Marketing Consultants", "Brand Strategists", "Public Relations Consultants", "SEO/SEM Specialists", "Direct Response Marketers", "Affiliate Marketers", "Market Research Consultants", "Event Marketers", "Customer Experience Consultants", "Conversion Optimization Specialists", "Email Marketing Consultants", "Sales Trainers", "Trade Show Specialists", "Product Demonstration Specialists"],
  },
  {
    title: "Transportation & Logistics",
    icon: "Truck",
    items: ["Owner-Operator Truck Drivers", "Logistics Consultants", "Fleet Management Specialists", "Supply Chain Consultants", "Transportation Planners", "Private Pilots & Flight Instructors", "Marine Logistics Specialists", "Import/Export Consultants", "Customs Brokers", "Freight Forwarding Specialists"],
  },
  {
    title: "Hospitality & Tourism",
    icon: "UtensilsCrossed",
    items: ["Private Chefs", "Event Planners", "Travel Consultants", "Tour Operators", "Vacation Property Managers", "Restaurant Consultants", "Hotel Developers", "Food Stylists & Photographers", "Specialty Caterers", "Wine Consultants & Sommeliers"],
  },
  {
    title: "Specialized Fields",
    icon: "Microscope",
    items: ["Agricultural Consultants", "Aviation Consultants", "Energy Consultants", "Environmental Compliance Specialists", "Scientific Researchers", "Technical Translators", "Medical Writers", "Grant Writers", "Professional Speakers", "Industrial Designers", "Sustainability Consultants", "Data Scientists", "Clinical Research Associates", "Biotech Consultants", "Pharmaceutical Consultants"],
  },
];



export const blogPosts = [
  {
    id: 1,
    title: "Private Health Insurance vs. Marketplace Plans: What You Need to Know in 2025",
    excerpt: "With premiums rising across the board, understanding the real differences between private insurance and marketplace plans has never been more important. Here's what I tell my clients.",
    category: "Education",
    date: "June 15, 2025",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=600&h=400&fit=crop",
    content: `If you're shopping for health insurance in 2025, you've probably noticed that premiums are going up — again. The average marketplace premium increased by about 7% this year, and group plan premiums are up nearly 9%.\n\nSo what does that mean for you? It depends on your situation.\n\n**Marketplace Plans (ACA)**\nMarketplace plans offer guaranteed acceptance regardless of pre-existing conditions, and if your income qualifies, you may receive subsidies that significantly lower your monthly premium. These plans follow standardized benefit tiers (Bronze, Silver, Gold, Platinum), making comparisons somewhat easier.\n\n**Private Health Insurance**\nPrivate plans, purchased through a broker like me, often come with larger provider networks, more customization options, and for healthy individuals, potentially lower premiums through underwriting. You can also enroll year-round — no waiting for open enrollment.\n\n**My Recommendation**\nThere's no one-size-fits-all answer. If you have pre-existing conditions or qualify for significant subsidies, marketplace plans may be your best bet. If you're generally healthy and want more flexibility, private insurance could save you 30-40% while giving you better coverage.\n\nThat's exactly why I exist — to help you compare both options side by side and figure out what actually makes sense for your situation. Give me a call and we'll sort it out together.`,
  },
  {
    id: 2,
    title: "Small Business Health Insurance: 6 Options You Should Know About",
    excerpt: "Group plans aren't your only option anymore. Here are six ways small business owners can provide health benefits to their team in 2025.",
    category: "Small Business",
    date: "May 28, 2025",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=600&h=400&fit=crop",
    content: `If you run a small business, you know health insurance is one of the biggest challenges you face. Good news: you have more options than ever.\n\n**1. Traditional Group Plans**\nThe classic approach — you choose a plan from a carrier and share the cost with employees. Works well for businesses with 5+ employees who want standardized coverage.\n\n**2. SHOP Marketplace**\nFor businesses with 1-50 employees, the SHOP marketplace offers ACA-compliant plans. If you cover at least 50% of premiums and have fewer than 25 employees, you may qualify for the Small Business Health Care Tax Credit.\n\n**3. ICHRA (Individual Coverage HRA)**\nThis is a game-changer. You set a monthly allowance, and employees use it to buy their own individual health plans. It works for any size business, contributions are tax-free, and employees get to choose coverage that fits their needs.\n\n**4. QSEHRA**\nSimilar to ICHRA but designed for businesses with fewer than 50 employees that don't offer group plans. There are annual contribution caps, but it's a simple, flexible option.\n\n**5. Level-Funded Plans**\nA hybrid between fully insured and self-funded. You pay a fixed monthly amount that covers claims, stop-loss insurance, and administration. If claims come in low, you may get money back.\n\n**6. Association Health Plans**\nJoin forces with other small businesses in your industry to access group rates typically reserved for larger companies.\n\nNot sure which option is right for your team? That's literally what I do. Let's talk about your situation and find the best fit.`,
  },
  {
    id: 3,
    title: "Self-Employed? Here's How to Stop Overpaying for Health Insurance",
    excerpt: "As a freelancer, consultant, or sole proprietor, you might be leaving money on the table. Here's how to get better coverage for less.",
    category: "Self-Employed",
    date: "May 10, 2025",
    readTime: "4 min read",
    image: "https://images.unsplash.com/photo-1553877522-43269d4ea984?w=600&h=400&fit=crop",
    content: `Being self-employed comes with a lot of freedom — and a lot of responsibility. Health insurance is often one of the most frustrating parts.\n\nHere's what I've learned working with hundreds of self-employed clients:\n\n**You Might Be Overpaying**\nMany self-employed professionals default to marketplace plans because they don't know what else is available. While marketplace plans are great for some, healthy individuals often pay significantly more than they need to.\n\n**Private Plans Can Save You 30-40%**\nIf you're in good health, private insurance plans use underwriting to offer you lower premiums based on your actual risk profile. Unlike marketplace plans, you're not paying the same rate as everyone else.\n\n**Year-Round Enrollment**\nOne of the biggest advantages of private plans: you can enroll any time. No waiting for open enrollment periods, no needing a qualifying life event.\n\n**Tax Benefits**\nSelf-employed individuals can deduct 100% of health insurance premiums as a business expense. If you pair a high-deductible plan with an HSA, you get even more tax savings.\n\n**What To Do Next**\nDon't just auto-renew your current plan. Take 15 minutes to have a conversation with me, and I'll show you what's actually available. You might be surprised at how much you can save.`,
  },
  {
    id: 4,
    title: "Understanding HSAs: The Most Underused Tax Advantage in Health Insurance",
    excerpt: "Health Savings Accounts can save you thousands in taxes while building a health care safety net. Here's how they work.",
    category: "Education",
    date: "April 22, 2025",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&h=400&fit=crop",
    content: `If you have a high-deductible health plan (HDHP), you have access to one of the best tax advantages available: a Health Savings Account.\n\n**Triple Tax Benefit**\nHSAs offer something almost no other financial tool does — a triple tax advantage:\n1. Contributions are tax-deductible (or pre-tax through payroll)\n2. Earnings grow tax-free\n3. Withdrawals for qualified medical expenses are tax-free\n\n**2025 Contribution Limits**\n- Individual: $4,300\n- Family: $8,550\n- Catch-up (55+): Additional $1,000\n\n**Why More People Should Use Them**\nUnlike FSAs, HSA funds roll over year to year. You never lose them. Many people use their HSA as a long-term investment vehicle — paying current medical expenses out of pocket and letting their HSA balance grow for retirement.\n\n**Is an HDHP + HSA Right for You?**\nIt depends on your health care usage patterns and financial situation. If you're generally healthy and don't have high ongoing prescription costs, an HDHP with an HSA often makes more sense financially than a traditional PPO.\n\nI help clients run the numbers on this every day. Let's figure out if this strategy works for you.`,
  },
  {
    id: 5,
    title: "Open Enrollment 2025: What Changed and What You Should Do Now",
    excerpt: "Key changes for the 2025 plan year and the steps you should take to make sure you have the right coverage.",
    category: "Updates",
    date: "April 5, 2025",
    readTime: "4 min read",
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=600&h=400&fit=crop",
    content: `Each year, health insurance plans change — sometimes in small ways, sometimes significantly. Here's what's different for 2025.\n\n**Premium Increases**\nAcross the board, premiums have increased 7-9%. This affects both marketplace and employer-sponsored plans. If you auto-renewed without reviewing your options, you may be paying more than necessary.\n\n**Network Changes**\nSeveral major insurers have adjusted their provider networks. Some have exited certain markets entirely. If your preferred doctors or hospitals are important to you, it's worth double-checking your current plan's network.\n\n**New Plan Options**\nNew carriers and plan designs have entered the market, including more ICHRA-compatible individual plans and innovative level-funded options for small businesses.\n\n**What You Should Do**\n1. Don't auto-renew blindly — review your current plan's changes\n2. Compare your out-of-pocket costs, not just premiums\n3. Verify your doctors are still in-network\n4. Consider whether private insurance might be a better fit this year\n5. Talk to a broker (hi, that's me) who can compare all your options\n\nRemember: the cheapest premium isn't always the best deal. Total cost of care matters more.`,
  },
  {
    id: 6,
    title: "5 Questions to Ask Before Choosing a Health Insurance Plan",
    excerpt: "Choosing a health plan doesn't have to feel overwhelming. Start with these five questions and the right answer usually becomes clear.",
    category: "Tips",
    date: "March 18, 2025",
    readTime: "3 min read",
    image: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=600&h=400&fit=crop",
    content: `I've helped hundreds of people choose health insurance plans. Here are the five questions that cut through the confusion every time:\n\n**1. Are my current doctors in-network?**\nThis is the most important question for most people. A plan with a low premium means nothing if you can't see the doctors you trust.\n\n**2. What are my total expected costs — not just the premium?**\nPremium is what you pay monthly. But deductibles, copays, coinsurance, and out-of-pocket maximums all affect what you actually spend. A $200/month plan with a $7,000 deductible might cost more than a $400/month plan with a $1,500 deductible.\n\n**3. What prescriptions do I take?**\nDrug formularies vary widely between plans. Check that your medications are covered and what tier they fall into. This can make a huge difference in your monthly costs.\n\n**4. Do I need specialist access?**\nSome plans require referrals to see specialists. If you regularly see specialists, make sure your plan allows direct access.\n\n**5. What's my risk tolerance?**\nHigh-deductible plans have lower premiums but more financial risk if something happens. Traditional plans cost more monthly but offer more predictability. Neither is inherently better — it depends on your comfort level.\n\nStill not sure? That's what I'm here for. These conversations are free and there's never any pressure.`,
  },
];

export const googleReviews = [
  {
    id: 1,
    name: "Jaime Jimenez",
    date: "Dec 2025",
    rating: 5,
    text: "I had the pleasure of working with Kimberly Hess and am pleased to offer an excellent review for her knowledge and expertise on the subject of Health Insurance, regulatory requirements and industry best practices.",
    source: "Google",
  },
  {
    id: 2,
    name: "Jeffrey Pickett",
    date: "Dec 2025",
    rating: 5,
    text: "Not a person who leaves a lot of reviews, but Kimberly was instrumental and helping me answer all the questions that I needed and becoming my agent. I have a few complex situations that she helped guide me and find the best workaround for my situation. Would highly recommend and she will be my agent as long as she continues this line of business.",
    source: "Google",
  },
  {
    id: 3,
    name: "Ashley Nowell",
    date: "Dec 2025",
    rating: 5,
    text: "Kim was such a great help and knowledgeable in choosing the best plan for me and my needs.",
    source: "Google",
  },
  {
    id: 4,
    name: "Katie Golinowski",
    date: "Dec 2025",
    rating: 5,
    text: "Kim was wonderful. She explained all of my options, walked me through all the details of the plan I chose and was just overall very thorough and extremely kind.",
    source: "Google",
  },
  {
    id: 5,
    name: "Destiny DiGirolamo",
    date: "Dec 2025",
    rating: 5,
    text: "Found our family a plan that gave us everything we need plus saved us a ton of money!!",
    source: "Google",
  },
  {
    id: 6,
    name: "Cameron Cochran",
    date: "Dec 2025",
    rating: 5,
    text: "I love working with Kim! She is very responsive and so helpful in answering any questions I have about my insurance policy. She has made everything super easy to set up and understand!",
    source: "Google",
  },
  {
    id: 7,
    name: "David Mansfield",
    date: "Nov 2025",
    rating: 5,
    text: "Kim is amazing and easy to work with! She explains things in this crazy health insurance world in a way that's understandable and clear. She gives many options and finds the right fit for you and your needs. Just like many other health insurance providers, she is spread thin but always makes the time to take care of her people.",
    source: "Google",
  },
  {
    id: 8,
    name: "Marie Mantle",
    date: "Oct 2025",
    rating: 5,
    text: "Kimberly was so helpful in finding the right plan for my family and has saved us so much hassle with medical bills. She is very knowledgeable and also helped us with some other supplemental plans that are great for peace of mind.",
    source: "Google",
  },
  {
    id: 9,
    name: "Kelly Tenedini",
    date: "Sep 2025",
    rating: 5,
    text: "Even though I'm in another state, she was able to answer all my health insurance questions and break it down in a way that actually made sense. It's so nice knowing she can help me, my family, and my friends no matter where we live since she's licensed in multiple states. If you ever need someone who actually cares and knows her stuff, Kim's your girl!",
    source: "Google",
  },
  {
    id: 10,
    name: "Frankie A",
    date: "Sep 2025",
    rating: 5,
    text: "I recently had the pleasure of working with Kim Hess to find the right insurance plan for my HVAC company's employees, and I can't recommend her highly enough. She went above and beyond to find a solution that was both affordable and a perfect fit for our team, who are mostly older employees with specific needs.",
    source: "Google",
  },
  {
    id: 11,
    name: "Jonathan Tyree",
    date: "Sep 2025",
    rating: 5,
    text: "Hess insurance has made finding and obtaining insurance so easy. They are very friendly and personable. They find your needs and work with that. I highly recommend them to anyone.",
    source: "Google",
  },
  {
    id: 12,
    name: "Heidi Baker",
    date: "Aug 2025",
    rating: 5,
    text: "I love working with Kimberly. She is so easy to talk to and she is also very knowledgeable which puts me at ease. I greatly recommend her!",
    source: "Google",
  },
  {
    id: 13,
    name: "Wyant Photography and Gallery",
    date: "Jul 2025",
    rating: 5,
    text: "Kim has been amazing, setting me up with health insurance. I don't know about you, but I find insurance CONFUSING! Kim made it easy to understand and made me feel confident that I have the right coverage for me. She then went further and helped me through the website, explained how to find doctors within the coverage, and how to submit claims.",
    source: "Google",
  },
  {
    id: 14,
    name: "Amie Hawks",
    date: "Jul 2025",
    rating: 5,
    text: "Kimberly is a solid professional who has a genuine interest in helping people. She's always willing to help and very clear with her communication, schedule and timelines. She's also personable and easy to interact with, which is important when dealing with insurance matters. I highly recommend her!",
    source: "Google",
  },
  {
    id: 15,
    name: "Victoria Haffer",
    date: "Jul 2025",
    rating: 5,
    text: "Kimberly Hess has such an amazing way about her. She actually cares about her clients and will do her due diligence to get you the best policy for the best price! I would highly recommend Kimberly for all your health insurance needs.",
    source: "Google",
  },
  {
    id: 16,
    name: "Chloe Kelley",
    date: "Jul 2025",
    rating: 5,
    text: "Kim is amazing! So helpful and always there when you need her! 10/10 recommend!",
    source: "Google",
  },
];
